define([
	"dojo/_base/declare",
	"csi/action/EditController",
	"csi/xml",
], function(declare, EditController, xml) {

	return declare(EditController, {
		/**
		 * @override
		 * Provide custom operation since text is being set for specific index into Remarks vector
		 */
		toWriter() {
			const {keyContainer, m_urlNode, m_writer} = this;
			const value = this.getFormData().getFieldValue("Remarks");

			m_writer.changeNode(m_urlNode).changeAttributeKeys("Remarks", xml.ATTR_STRINGMAP, {[keyContainer]: value});
		},

		/**
		 * @override
		 * Redraw row
		 */
		postProcessSuccess() {
			this.widget.redrawNode(this.refNode);
		}
	});
});